import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { SizeMe } from 'react-sizeme';

import Viewer from 'components/training/attachments/components/Viewer';
import Uploader from 'components/uploader/Uploader';

const colWidth = 128;
const gutterWidth = 6;

const gridWidthNumCols = [...Array(5).keys()].reduce((obj, index) => {
  const totalCols = colWidth * (index + 1);
  const totalGutters = gutterWidth * index;

  obj[index + 1] = totalCols + totalGutters;

  return obj;
}, {});

export default function Attachments({
  attachments,
  maxUploads,
  onCreate,
  onDelete,
  onPollingSuccess,
  onRotateClick,
  onRotateSuccess,
  onUpload,
}) {
  const attachmentsClass = (width) => {
    switch (true) {
      case width > gridWidthNumCols[5]:
        return 'attachments--cols-5';
      case width > gridWidthNumCols[4]:
        return 'attachments--cols-4';
      case width > gridWidthNumCols[3]:
        return 'attachments--cols-3';
      case width > gridWidthNumCols[2]:
        return 'attachments--cols-2';
      default:
        return 'attachments--cols-1';
    }
  };

  return (
    <SizeMe>
      {({ size }) => (
        <div
          className={classNames('attachments', attachmentsClass(size.width))}
        >
          {size.width && (
            <div className='-tw-m-1.5 tw-flex tw-flex-row tw-flex-wrap tw-overflow-auto'>
              <Uploader
                maxUploads={maxUploads}
                mode='compact'
                onUpload={onUpload}
                uploadsCount={attachments.length}
              />
              {attachments.map((attachment, index) => (
                <Viewer
                  attachment={attachment}
                  index={index}
                  key={attachment.key || attachment.id}
                  onCreate={onCreate}
                  onDelete={onDelete}
                  onPollingSuccess={onPollingSuccess}
                  onRotateClick={onRotateClick}
                  onRotateSuccess={onRotateSuccess}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </SizeMe>
  );
}

Attachments.propTypes = {
  attachments: PropTypes.array.isRequired,
  maxUploads: PropTypes.number,
  onCreate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onPollingSuccess: PropTypes.func.isRequired,
  onRotateClick: PropTypes.func.isRequired,
  onRotateSuccess: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
};
